import { inject, Injectable } from "@angular/core";
import { Endpoint } from "@pcp/http";

@Injectable({
    providedIn: 'root'
})
export class WebPushApiService {
    private readonly endpoint = inject(Endpoint);

    public sendSubscription(subscription: PushSubscription) {
        this.endpoint.post('/api/push/subscribe', subscription.toJSON()).subscribe();
    }

    public unregisterSubscription(subscription: PushSubscription) {
        throw new Error('Method not implemented.');
        this.endpoint.post('/api/push/unsubscribe', subscription.toJSON()).subscribe();
    }
}
